export enum CopyConfigurationColumns {
  Description = 'Description',
  Slug = 'Slug',
  Type = 'Type',
  Favorite = 'Favorite'
}
